import React, { ChangeEvent, useEffect, useState } from 'react'
import { StateMethods } from '@hookstate/core'
import {
  IconButton,
  InputAdornment,
  SxProps,
  TextField,
  TextFieldVariants,
  Theme,
} from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'
import { set } from 'lodash'

interface IInputSearchWithClear {
  readonly search: StateMethods<string>
  readonly placeholder: string
  readonly sx?: SxProps<Theme> | undefined
  readonly fullWidth?: boolean | undefined
  readonly disabled?: boolean
  readonly variant?: TextFieldVariants
  readonly inputRef?: React.Ref<HTMLInputElement>
  readonly loading?: boolean
  readonly onClear?: () => void
}
export function InputSearchWithClear({
  fullWidth,
  sx,
  search,
  placeholder,
  disabled = false,
  variant = 'outlined',
  inputRef,
  loading,
  onClear,
}: IInputSearchWithClear) {
  const [value, setValue] = useState<string>('');

  useEffect(() => {
    if (!search.value || !loading) {
      setValue(search.value || '')
    }
  }, [search.value, loading])

  return (
    <TextField
      id="outlined-search"
      variant={variant}
      inputRef={inputRef}
      sx={sx}
      fullWidth={fullWidth}
      defaultValue={search.get()}
      value={value}
      onChange={(event: ChangeEvent<HTMLInputElement>) => {
        search.set(event.target.value)
        setValue(event.target.value)
      }}
      size="small"
      placeholder={placeholder}
      disabled={disabled}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {search.get() && String(search.get()).length > 0 && (
              <IconButton
                aria-label="toggle clear search"
                onClick={() => {
                  search.set('')
                  setValue('')
                  onClear?.()
                }}
                disabled={disabled}
                edge="end"
                size="small"
              >
                <CancelIcon fontSize="small" />
              </IconButton>
            )}
          </InputAdornment>
        ),
      }}
    />
  )
}
